const columns = [
  {
    title: '浏览图集',
    links: [
      { label: '最新图集', href: '#latest' },
      { label: '热门作品', href: '#hot' },
      { label: '风格分类', href: '#styles' },
      { label: '画师精选', href: '#artists' },
    ],
  },
  {
    title: '帮助与支持',
    links: [
      { label: '关于我们', href: '#about' },
      { label: '常见问题', href: '#faq' },
      { label: '订阅每日更新', href: '#subscribe' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full border-t border-background-200/60 bg-background-200/40">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-t-shirt-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-50">
                娜美同人<span className="text-primary-400">图鉴</span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-300">
              高清同人插画与壁纸的收藏乐园，汇集多位画师作品，每日更新，尊重版权、支持投稿。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {[
                { icon: 'ri-mail-line', label: '邮箱' },
                { icon: 'ri-twitter-x-line', label: '社交平台' },
                { icon: 'ri-bilibili-line', label: '视频平台' },
              ].map((item) => (
                <a
                  key={item.label}
                  href="mailto:hi@namigallery.example"
                  aria-label={item.label}
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-background-300/40 text-foreground-300 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${item.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-foreground-50">
                {col.title}
              </h3>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-300 transition-colors hover:text-primary-400"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200/60 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-400">
            © 2026 娜美同人图鉴 · 所有作品版权归原作者所有，仅作个人收藏与欣赏。
          </p>
          <p className="flex items-center gap-1.5 text-xs text-foreground-400">
            <i className="ri-mail-line"></i>
            hi@namigallery.example
          </p>
        </div>
      </div>
    </footer>
  );
}